"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.luZones = exports.luSubZoneNameMapping = void 0;
var luZones = exports.luZones = [{
  id: 'LUXEMBOURG',
  name: 'Luxembourg',
  country: 'LU',
  cornerNW: {
    latitude: 49.6489,
    longitude: 6.0613
  },
  cornerSE: {
    latitude: 49.5734,
    longitude: 6.2194
  },
  subZones: [{
    name: 'Luxembourg',
    zipcodes: {
      1: {
        label: 'Luxembourg (postal codes starting with 1)'
      },
      2: {
        label: 'Luxembourg (postal codes starting with 2)'
      }
    }
  }]
}];
var luSubZoneNameMapping = exports.luSubZoneNameMapping = [{
  old: 'Luxembourg Centre ville',
  "new": 'Luxembourg'
}, {
  old: 'Luxembourg Europäesche Quartier',
  "new": 'Luxembourg'
}, {
  old: 'Luxembourg Kierchbierg',
  "new": 'Luxembourg'
}, {
  old: 'Luxembourg Findel',
  "new": 'Luxembourg'
}];